import { useMemo } from "react";

import { COLORS } from "./dioramaLayout";

function pseudoRandom(seed: number): number {
  return ((Math.sin(seed) * 43758.5453) % 1 + 1) % 1;
}

const PEBBLE_COLORS = [COLORS.cream, COLORS.coral2, COLORS.teal, COLORS.pink];

export function Pebbles() {
  const pebbles = useMemo(() => {
    return Array.from({ length: 15 }, (_, i) => {
      const angle = pseudoRandom(i * 1.7) * Math.PI * 2;
      const dist = 2 + pseudoRandom(i * 2.9) * 5;
      return {
        key: i,
        position: [
          Math.cos(angle) * dist,
          0.04,
          Math.sin(angle) * dist,
        ] as [number, number, number],
        radius: 0.06 + pseudoRandom(i * 4.1) * 0.08,
        color: PEBBLE_COLORS[Math.floor(pseudoRandom(i * 5.3) * 4)],
        rotY: pseudoRandom(i * 6.7) * Math.PI,
      };
    });
  }, []);

  return (
    <>
      {pebbles.map((p) => (
        <mesh
          key={p.key}
          position={p.position}
          scale={[1, 0.5, 1]}
          rotation={[0, p.rotY, 0]}
        >
          <dodecahedronGeometry args={[p.radius, 0]} />
          <meshStandardMaterial color={p.color} flatShading />
        </mesh>
      ))}
    </>
  );
}
